module.exports = __webpack_public_path__ + "assets/img/33_836_big.3f34aece.jpg";